<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="page-head">
      <div class="page-head-text">
        <h1 class="title-default">Painel de Automações</h1>
        <p class="welcome-message">
          <button mat-icon-button routerLink="/configuracoes/suprimentos" matTooltip="Voltar">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Ações automáticas, movimentações de etapa, lançamentos e notificações do Kanban de Compras.
        </p>
      </div>

    </div>

    <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

    @if (carregando) {
    <div class="automacoes-loading">
      <app-loading-box height="120" margin="0 0 16px 0"></app-loading-box>
      <app-loading-box height="120" margin="0 0 16px 0"></app-loading-box>
      <app-loading-box height="120" margin="0 0 16px 0"></app-loading-box>
      <app-loading-box height="120" margin="0 0 16px 0"></app-loading-box>
    </div>
    } @else {

      <section class="section-container" id="acoes">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">toggle_on</mat-icon>
          <span>Ações automáticas</span>
        </div>
        <p class="section-sub-title">Disparam sozinhas no gatilho indicado. Apenas ative ou pause.</p>

        <div class="automation-list">
          @for (acao of acoes; track acao.id) {
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon">
                <mat-icon class="material-symbols-outlined">{{ acao.icon }}</mat-icon>
              </span>
              <div class="identity-copy">
                <div class="identity-title">
                  <strong>{{ acao.nome }}</strong>
                  @if (acaoBloqueada(acao)) {
                  <span class="incomplete-pill incomplete-pill--hint"
                    matTooltip="Sem a etapa Aprovação de Pedido não há aprovação para disparar o envio. Ative a etapa no fluxo do Kanban para ligar esta automação; enquanto isso, envie o pedido pelo botão na etapa Pedido de Compra.">
                    <mat-icon class="material-symbols-outlined">warning</mat-icon>
                    Aprovação de Pedido desativada
                  </span>
                  }
                </div>
                <p>{{ acao.descricao }}</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card config-card--small">
              <div class="when-box">
                <mat-icon class="material-symbols-outlined">bolt</mat-icon>
                <div>
                  <span>Quando</span>
                  <strong>{{ acao.gatilho }}</strong>
                </div>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" [(ngModel)]="acao.ativa" color="primary"
                [disabled]="acaoBloqueada(acao)" (change)="salvarAutomacoes()"></mat-slide-toggle>
            </div>
          </div>
          } @empty {
          <app-empty-state icon="bolt" title="Nenhuma automação nesta seção"></app-empty-state>
          }
        </div>
      </section>

      <section class="section-container" id="movimentacoes">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
          <span>Movimentações automáticas</span>
        </div>
        <p class="section-sub-title">Movem o card de uma etapa para outra quando a condição é atendida.</p>

        <div class="automation-list">
          @for (movimento of movimentos; track movimento.id) {
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon">
                <mat-icon class="material-symbols-outlined">{{ movimento.icon }}</mat-icon>
              </span>
              <div class="identity-copy">
                <strong>{{ movimento.quando }}</strong>
                <span class="category-pill">{{ movimento.categoria }}</span>
                @if (movimentoIncompleto(movimento)) {
                <span class="incomplete-pill">
                  <mat-icon class="material-symbols-outlined">warning</mat-icon>
                  Configuração incompleta
                </span>
                }
                <p>{{ movimento.descricao }}</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card">
              <div class="move-target">
                <span class="move-label">
                  <mat-icon class="material-symbols-outlined">east</mat-icon>
                  Mover o card para
                </span>
                <span class="stage-pill" [style.color]="movimento.corDestino" [style.border-color]="movimento.corDestino + '33'"
                  [style.background]="movimento.corDestino + '14'">
                  <i [style.background]="movimento.corDestino"></i>
                  {{ movimento.destino }}
                </span>
              </div>
              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" [(ngModel)]="movimento.ativa" color="primary"
                (change)="salvarAutomacoes()"></mat-slide-toggle>
            </div>
          </div>
          } @empty {
          <app-empty-state icon="bolt" title="Nenhuma automação nesta seção"></app-empty-state>
          }
        </div>
      </section>

      <section class="section-container" id="lancamentos">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
          <span>Lançamentos</span>
        </div>
        <p class="section-sub-title">Lançam estoque e financeiro ao mover o card para Finalizado, a partir da origem escolhida.</p>

        <div class="automation-list">
          @for (lancamento of lancamentos; track lancamento.id) {
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon">
                <mat-icon class="material-symbols-outlined">{{ lancamento.icon }}</mat-icon>
              </span>
              <div class="identity-copy">
                <strong>{{ lancamento.nome }}</strong>
                <span class="category-pill">{{ lancamento.categoria }}</span>
                @if (lancamentoIncompleto(lancamento)) {
                <span class="incomplete-pill">
                  <mat-icon class="material-symbols-outlined">warning</mat-icon>
                  Configuração incompleta
                </span>
                }
                <p>{{ lancamento.descricao }}</p>
                <span class="permission-pill" [matTooltip]="lancamento.permissao">
                  <mat-icon class="material-symbols-outlined">admin_panel_settings</mat-icon>
                  {{ lancamento.permissaoNome }}
                </span>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card config-card--stacked config-card--finance">
              <div class="inline-control" [class.field-disabled]="!lancamento.ativa">
                <span>Quando</span>
                <div class="when-fixed">
                  <mat-icon class="material-symbols-outlined">bolt</mat-icon>
                  <strong>{{ gatilhoLancamento }}</strong>
                </div>
              </div>

              <div class="inline-control" [class.field-disabled]="!lancamento.ativa">
                <span>Gerar</span>
                <div class="source-stack">
                  <div class="source-options">
                    @for (origem of origensLancamento; track origem.id) {
                    <button type="button" [class.active]="lancamento.idOrigemLancamento === origem.id"
                      [disabled]="!lancamento.ativa" (click)="lancamento.idOrigemLancamento = origem.id; salvarAutomacoes()"
                      [matTooltip]="origem.hint">
                      <mat-icon class="material-symbols-outlined">{{ origem.icon }}</mat-icon>
                      {{ origem.label }}
                    </button>
                    }
                  </div>
                  @if (lancamento.idOrigemLancamento === OrigemLancamentoEnum.NotaFiscal) {
                  <p class="finance-note">
                    <mat-icon class="material-symbols-outlined">info</mat-icon>
                    Se o pedido não tiver nota fiscal associada, o lançamento será gerado pelo pedido.
                  </p>
                  }
                </div>
              </div>

              @if (!lancamento.ativa) {
              <div class="lancamento-hints">
                <p class="blocked-hint">
                  <mat-icon class="material-symbols-outlined">lock</mat-icon>
                  Ative a automação para configurar os campos.
                </p>
              </div>
              }

              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" [(ngModel)]="lancamento.ativa" color="primary"
                (change)="salvarAutomacoes()"></mat-slide-toggle>
            </div>
          </div>
          } @empty {
          <app-empty-state icon="bolt" title="Nenhuma automação nesta seção"></app-empty-state>
          }
        </div>
      </section>

      <section class="section-container" id="notificacoes">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">notifications</mat-icon>
          <span>Notificações</span>
          <div class="section-title-actions ms-auto">
            <button mat-button type="button" class="btn-section" (click)="adicionarNotificacao()">
              <mat-icon class="material-symbols-outlined">add</mat-icon>
              Adicionar automação
            </button>
          </div>
        </div>
        <p class="section-sub-title">Avise pessoas específicas quando o gatilho escolhido ocorrer.</p>

        <div class="automation-list">
          @for (notificacao of notificacoes; track notificacao.id) {
          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon">
                <mat-icon class="material-symbols-outlined">{{ notificacao.icon }}</mat-icon>
              </span>
              <div class="identity-copy">
                <strong>{{ notificacao.nome }}</strong>
                <span class="category-pill">{{ notificacao.categoria }}</span>
                @if (notificacaoIncompleta(notificacao)) {
                <span class="incomplete-pill">
                  <mat-icon class="material-symbols-outlined">warning</mat-icon>
                  Configuração incompleta
                </span>
                }
                <p>{{ notificacao.descricao }}</p>
              </div>
            </div>
            <span class="connector"></span>
            <div class="config-card config-card--stacked config-card--notification">
              <div class="inline-control" [class.field-disabled]="!notificacao.ativa">
                <span>Quando</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">low_priority</mat-icon>
                  <mat-select #gatilhoNotificacao [(ngModel)]="notificacao.idTipoOcorrenciaCompra"
                    placeholder="Selecionar gatilho" [disabled]="!notificacao.ativa"
                    (selectionChange)="salvarAutomacoes()" panelClass="notificacao-select-panel">
                    @for (gatilho of gatilhos; track gatilho.id) {
                    <mat-option [value]="gatilho.id">{{ gatilho.label }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="inline-control" [class.field-disabled]="!notificacao.ativa">
                <span>Notificar</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-icon matPrefix class="material-symbols-outlined">group</mat-icon>
                  <mat-select #destinatariosNotificacao [(ngModel)]="notificacao.destinatarios" multiple
                    [compareWith]="mesmoDestinatario"
                    placeholder="Selecionar destinatários" [disabled]="!notificacao.ativa"
                    (closed)="salvarAutomacoes()" panelClass="notificacao-select-panel notificacao-recipient-panel">
                    <mat-select-trigger>
                      <span class="recipient-chips">
                        @for (d of notificacao.destinatarios; track $index) {
                        <span class="recipient-chip" [class.recipient-chip--dynamic]="metaDestinatario(d).dinamico">
                          <mat-icon class="material-symbols-outlined">{{ metaDestinatario(d).icon }}</mat-icon>{{ metaDestinatario(d).label }}
                        </span>
                        }
                      </span>
                    </mat-select-trigger>
                    <mat-optgroup label="Do card">
                      @for (destinatario of destinatariosDoCard; track $index) {
                      <mat-option [value]="destinatario.destinatario">
                        <span class="opt-chip opt-chip--dynamic">
                          <mat-icon class="material-symbols-outlined">{{ destinatario.icon }}</mat-icon>
                        </span>
                        <span class="opt-label">{{ destinatario.label }}</span>
                      </mat-option>
                      }
                    </mat-optgroup>
                    <mat-optgroup label="Por perfil">
                      @for (destinatario of destinatariosPorPerfil; track $index) {
                      <mat-option [value]="destinatario.destinatario">
                        <span class="opt-chip">
                          <mat-icon class="material-symbols-outlined">{{ destinatario.icon }}</mat-icon>
                        </span>
                        <span class="opt-label">{{ destinatario.label }}</span>
                      </mat-option>
                      }
                    </mat-optgroup>
                    <mat-optgroup label="Por usuário">
                      @for (destinatario of destinatariosPorUsuario; track $index) {
                      <mat-option [value]="destinatario.destinatario">
                        <span class="opt-chip">
                          <mat-icon class="material-symbols-outlined">{{ destinatario.icon }}</mat-icon>
                        </span>
                        <span class="opt-label">{{ destinatario.label }}</span>
                      </mat-option>
                      }
                    </mat-optgroup>
                  </mat-select>
                </mat-form-field>
              </div>

              @if (!notificacao.ativa) {
              <p class="blocked-hint">
                <mat-icon class="material-symbols-outlined">lock</mat-icon>
                Ative a automação para configurar os campos.
              </p>
              }

              <span class="divider"></span>
              <mat-slide-toggle class="app-toggle-compact" [(ngModel)]="notificacao.ativa" color="primary"
                (change)="gatilhoNotificacao.close(); destinatariosNotificacao.close(); salvarAutomacoes()"></mat-slide-toggle>
              <span [matTooltip]="notificacoes.length <= 1 ? 'A única notificação não pode ser removida; desative-a para pausar.' : 'Remover notificação'">
                <button type="button" mat-icon-button aria-label="Remover notificação"
                  [disabled]="notificacoes.length <= 1" (click)="removerNotificacao(notificacao.id)">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              </span>
            </div>
          </div>
          } @empty {
          <app-empty-state icon="bolt" title="Nenhuma automação nesta seção"></app-empty-state>
          }
        </div>
      </section>
    }

  </div>
</div>
